import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less'
import api from './utils/api.js'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-awesome/icons'
// import pinyin from './utils/utils';

Vue.use(less);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$api = api;
// Vue.prototype.pinyin = pinyin;

// setInterval(() => {1
//   console.log(1)
// }, 2000);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
